/**
 * Local storage keys for the tenant admin application.
 */
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_DATA: 'user',
  ACCOUNT_TYPE: 'account_type',
  TENANT_NAME: 'tenant_name',
  LAST_USER_ACTIVITY_MS: 'LAST_USER_ACTIVITY_MS',
  SESSION_WARNING_DEADLINE_MS: 'SESSION_WARNING_DEADLINE_MS',
  REMEMBER_ME: 'remember_me',
  REMEMBERED_EMAIL: 'remembered_email',
} as const;
